import React from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import * as routes from 'core/routing/constants/index'
import wizardsShape from 'core/components/wizard/shapes'
import { Row, Col, ButtonNext } from 'core/components/ui'
import MainContentWrapper from 'core/templates/MainContentWrapper'

import { calculateAlphaColor } from 'core/utils/colors'
import SVG from 'core/components/svg'
import svg from 'assets/svg'
import { font, greys } from 'assets/themes/theme-default'

const Title = styled.h1`
  color: ${props => props.theme.colors.color2.bg};
  text-transform: uppercase;
  font-weight: ${font.weight.black};
  font-size: ${font.size.lgxxl};
  margin: 70px 0 10px;
`

const SubTitle = styled.h3`
  color: ${props => props.theme.colors.color2.bg};
  font-weight: ${font.weight.base};
  font-size: ${font.size.lg};
  margin: 0px 0 20px;
`
const CardCta = styled(Row)`
  padding: 20px;
  background: ${greys.light4};
  min-height: 260px;
`

const CardOr = styled.div`
  text-transform: uppercase;
  border-radius: 200px;
  width: 80px;
  height: 80px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${greys.light4};
  font-weight: ${font.weight.base};
  font-size: ${font.size.lgsm};
  background-color: ${props => props.theme.colors.color2.bg};
  box-shadow: 0 0 0 20px ${props => calculateAlphaColor(props.theme.colors.color2.bg, 0.5)};
`

const CardTitle = styled.h4`
  color: ${props => props.theme.colors.color2.bg};
  font-weight: ${font.weight.base};
  font-size: ${font.size.lgsm};
`
const CardDescriptionWrapper = styled.p`
  font-weight: ${font.weight.base};
  font-size: ${font.size.base};
  color: ${greys.dark3};
`
const CardButtonWrapper = styled.div`
  margin: 20px 0 0 0;
`

const CardIcon = styled(SVG)`
  width: 40px;
  fill: ${props => props.theme.colors.color2.bg};
  margin-right: 10px;
`

const Congratulations = props => {
  const { setWizards, wizards, history } = props

  const aStepsActive = wizards[wizards.activeWizard]

  const activateNextStep = () => {
    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.STOCK_CONGRATULATIONS) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })
    const extentedWizards = { ...wizards, aStepsStock: extendedSteps }
    setWizards(extentedWizards)
    history.push(extendedStep.hash)
  }

  const activateFundingStep = () => {
    const tradeInIndex = aStepsActive.findIndex(step => step.hash === routes.STOCK_TRADEIN)
    const fundingIndex = aStepsActive.findIndex(step => step.hash === routes.STOCK_FUNDING)

    const extendedStep = { ...aStepsActive[tradeInIndex], isActive: true }
    const extendedStep2 = { ...aStepsActive[fundingIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [tradeInIndex]: extendedStep,
      [fundingIndex]: extendedStep2
    })

    const extentedWizards = { ...wizards, aStepsStock: extendedSteps }
    setWizards(extentedWizards)
    history.push(routes.STOCK_FUNDING)
  }

  const activateFinalizationStep = () => {
    const tradeInIndex = aStepsActive.findIndex(step => step.hash === routes.STOCK_TRADEIN)
    const fundingIndex = aStepsActive.findIndex(step => step.hash === routes.STOCK_FUNDING)
    const finalizationIndex = aStepsActive.findIndex(
      step => step.hash === routes.STOCK_FINALIZATION
    )
    const extendedStep = { ...aStepsActive[tradeInIndex], isActive: true }
    const extendedStep2 = { ...aStepsActive[fundingIndex], isActive: true }
    const extendedStep3 = { ...aStepsActive[finalizationIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [tradeInIndex]: extendedStep,
      [fundingIndex]: extendedStep2,
      [finalizationIndex]: extendedStep3
    })

    const extentedWizards = { ...wizards, aStepsStock: extendedSteps }
    setWizards(extentedWizards)
    history.push(routes.STOCK_FINALIZATION)
  }

  // first div => for animations
  return (
    <div>
      <MainContentWrapper data-test="component-stock-congratulations">
        <Row>
          <Col>
            <Title data-test="stock-congratulations-title">
              <FormattedMessage id="stock-congratulations-view-title" />
            </Title>
            <SubTitle data-test="stock-congratulations-subtitle">
              <FormattedMessage id="stock-congratulations-view-subtitle" />
            </SubTitle>
          </Col>
        </Row>
        <Row gutter={0} type="flex" align="middle">
          <Col span={10}>
            <CardCta>
              <Row type="flex" align="middle" justify="center">
                <Col>
                  <CardIcon svg={svg.questionMark} />
                </Col>
                <Col>
                  <CardTitle data-test="stock-congratulations-cardTitle">
                    <FormattedMessage id="stock-congratulations-card-1-title" />
                  </CardTitle>
                </Col>
              </Row>
              <CardDescriptionWrapper data-test="stock-congratulations-description">
                <FormattedMessage id="stock-congratulations-card-1-description" />
              </CardDescriptionWrapper>
              <CardButtonWrapper>
                <ButtonNext
                  onClick={() => activateNextStep()}
                  data-test="stock-congratulations-cta-1"
                >
                  <FormattedMessage id="stock-congratulations-card-1-cta-1" />
                </ButtonNext>
              </CardButtonWrapper>
              <CardButtonWrapper>
                <ButtonNext
                  onClick={() => activateFundingStep()}
                  data-test="stock-congratulations-cta-2"
                >
                  <FormattedMessage id="stock-congratulations-card-1-cta-2" />
                </ButtonNext>
              </CardButtonWrapper>
            </CardCta>
          </Col>
          <Col span={4}>
            <CardOr data-test="stock-congratulations-cardOr">
              <FormattedMessage id="stock-congratulations-or" />
            </CardOr>
          </Col>
          <Col span={10}>
            <CardCta>
              <Row type="flex" align="middle" justify="center">
                <Col>
                  <CardIcon svg={svg.questionMark} data-test="stock-congratulations-cardIcon" />
                </Col>
                <Col>
                  <CardTitle>
                    <FormattedMessage id="stock-congratulations-card-2-title" />
                  </CardTitle>
                </Col>
              </Row>
              <CardDescriptionWrapper>
                <FormattedMessage id="stock-congratulations-card-1-description" />
              </CardDescriptionWrapper>
              <CardButtonWrapper>
                <ButtonNext
                  onClick={() => activateFinalizationStep()}
                  data-test="stock-congratulations-cta-3"
                >
                  <FormattedMessage id="stock-congratulations-card-2-cta-1" />
                </ButtonNext>
              </CardButtonWrapper>
            </CardCta>{' '}
          </Col>
        </Row>
      </MainContentWrapper>
    </div>
  )
}

Congratulations.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired
}

export default withRouter(Congratulations)
